import { render, staticRenderFns } from "./EventStandings.vue?vue&type=template&id=e08b8678"
import script from "./EventStandings.vue?vue&type=script&lang=js"
export * from "./EventStandings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports